package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveTimer
import fr.manyverse.app.domain.repository.TimerRepository
import kotlinx.coroutines.flow.Flow

/**
 * Use case for observing active timers targeted at a specific user.
 * Emits when timers are created or stopped that target this user.
 */
class ObserveActiveTimersUseCase(
    private val timerRepository: TimerRepository
) {
    operator fun invoke(
        tableId: String,
        currentUserId: String
    ): Flow<List<ActiveTimer>> {
        return timerRepository.observeActiveTimers(
            tableId = tableId,
            currentUserId = currentUserId
        )
    }
}
